import * as React from "react";
const SvgBackdrop = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.25 4.5c0-.644.188-1.245.51-1.75H6.5a1.75 1.75 0 1 0 0 3.5h11.26a3.235 3.235 0 0 1-.51-1.75Zm6.5 0a3.25 3.25 0 0 0-3.25-3.25h-14a3.25 3.25 0 0 0-.75 6.413V16.5A4.75 4.75 0 0 1 1 21.25a.75.75 0 0 0 0 1.5h16.006c2.563-.001 4.27-.809 5.335-1.918 1.048-1.091 1.409-2.409 1.409-3.332V4.587h-.001l.001-.087Zm-1.5 2.74a3.235 3.235 0 0 1-1.75.51H7.25v8.75a6.236 6.236 0 0 1-2.188 4.75H17c2.234 0 3.525-.692 4.259-1.457.752-.784.991-1.716.991-2.293V7.24Zm0-2.74a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Zm-2.5 0a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgBackdrop;
